export const areResultsStale = (parkResults) => {
  return typeof parkResults?.timeLoaded === 'number' && parkResults.timeLoaded + 60 * 1000 <= Date.now(); // 1 min cache
};
export const getParkResultsById = (parkResults, parkId) => parkResults[parkId];
